export default [{
  path: '/painel-proposta',
  name: 'painel-proposta',
  component: () => import('@/app-modulo/comercial/proposta/PainelProposta.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-proposta',
    pageTitle: 'Painel de propostas',
    useButtonProposta: true,
    useButtonDashBoardComercial: true,
  },
  children: [
    {
      path: '/painel-proposta/proposta/:id',
      component: () => import('@/app-modulo/comercial/cadastro-proposta/CadastroProposta.vue'),
      name: 'cadastro-proposta',
    },
  ],
}]
